import { State_update, State_init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { PageHeader } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { ofArray, tail, head, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Page } from "./Types.fs.js";
import { parse } from "../../../fable_modules/fable-library-js.4.19.0/Int32.js";
import { int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { WebPart$3 } from "../../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(State_init, State_update, view, (_arg_1) => (new PageHeader(1, ["Administration: Banner"])), (_arg_3) => (!isEmpty(_arg_3) ? ((head(_arg_3) === "admin") ? (!isEmpty(tail(_arg_3)) ? ((head(tail(_arg_3)) === "banner") ? (!isEmpty(tail(tail(_arg_3))) ? ((head(tail(tail(_arg_3))) === "page") ? (isEmpty(tail(tail(tail(_arg_3)))) ? (new Page(1, [head(tail(tail(_arg_3)))])) : (isEmpty(tail(tail(tail(tail(_arg_3))))) ? (new Page(0, [parse(head(tail(tail(tail(_arg_3)))), 511, false, 32)])) : undefined)) : ((head(tail(tail(_arg_3))) === "new") ? (isEmpty(tail(tail(tail(_arg_3)))) ? (new Page(2, [])) : undefined) : (isEmpty(tail(tail(tail(_arg_3)))) ? (new Page(1, [head(tail(tail(_arg_3)))])) : undefined))) : (new Page(0, [1]))) : undefined) : undefined) : undefined) : undefined), (_arg_2) => {
    switch (_arg_2.tag) {
        case 1:
            return ofArray(["admin", "banner", _arg_2.fields[0]]);
        case 2:
            return ofArray(["admin", "banner", "new"]);
        default:
            if (_arg_2.fields[0] === 1) {
                return ofArray(["admin", "banner"]);
            }
            else {
                return ofArray(["admin", "banner", "page", int32ToString(_arg_2.fields[0])]);
            }
    }
}, (_arg) => {
    if (_arg.tag === 28) {
        return _arg.fields[0];
    }
    else {
        return undefined;
    }
});

//# sourceMappingURL=WebPart.fs.js.map
